<template>
  <nav
    class="navbar navbar-expand-lg navbar-dark shadow-sm fixed-top axion-navbar"
    :class="{ 'navbar-shift': sidebarOpen }"
  >
    <div
      class="container-fluid d-flex align-items-center justify-content-between"
    >
      <!-- Sidebar toggle -->
      <button
        class="btn btn-outline-light me-2"
        @click="$emit('toggle-sidebar')"
      >
        <i class="bi bi-list fs-5"></i>
      </button>

      <!-- Brand -->
      <router-link
        to="/"
        class="navbar-brand fw-bold d-flex align-items-center brand-text m-0"
        v-show="!sidebarOpen"
      >
        <img
          src="@/assets/AxionLogo.png"
          alt="Axion Logo"
          class="me-2 rounded-circle axion-logo"
        />
        <span class="academy-name">{{ academyName }}</span>
      </router-link>

      <!-- Navbar Links (Right Side) -->
      <div class="ms-auto d-flex align-items-center">
        <!-- Profile Dropdown -->
        <div class="dropdown">
          <button
            class="btn btn-pink btn-sm dropdown-toggle profile-btn"
            type="button"
            id="profileDropdown"
            data-bs-toggle="dropdown"
          >
            <i class="bi bi-person-circle"></i>
            <span class="d-none d-lg-inline ms-1">Profile</span>
          </button>
          <ul
            class="dropdown-menu dropdown-menu-end"
            aria-labelledby="profileDropdown"
          >
            <li>
              <router-link class="dropdown-item" to="/studentProfile">
                View Profile
              </router-link>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <button class="dropdown-item btnlogOut" @click="logout">
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { useRouter } from "vue-router";

export default {
  props: {
    sidebarOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      academyName: "Axion Academy",
    };
  },
  setup() {
    const router = useRouter();

    const logout = () => {
      localStorage.clear(); // clear token or any stored info
      router.push("/");
    };

    return { logout };
  },
};
</script>

<style scoped>
/* ===== Axion Academy Navbar ===== */
.axion-navbar {
  background: linear-gradient(90deg, #1a001f, #2b0033);
  opacity: 1 !important;
  z-index: 1050;
  box-shadow: 0 4px 15px rgba(255, 0, 204, 0.3);
  transition: margin-left 0.3s ease;
}

/* Shift content when sidebar is open */
.navbar-shift {
  margin-left: 250px;
}

/* Brand styles */
.axion-logo {
  width: 40px;
  height: 40px;
  border: 2px solid #ff00cc;
  box-shadow: 0 0 10px #ff00cc, 0 0 20px #ff00cc;
  transition: all 0.3s ease;
}

.academy-name {
  font-size: 1.25rem;
  color: #ff00cc;
  text-shadow: 0 0 10px #ff00cc, 0 0 20px #ff00cc;
  transition: all 0.3s ease;
}

/* Center brand on large screens */
.navbar .brand-text {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.profile-btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Mobile adjustments */
@media (max-width: 991px) {
  .brand-text {
    position: static;
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  .axion-logo {
    width: 30px;
    height: 30px;
    margin-right: 5px;
  }

  .academy-name {
    font-size: 1rem;
    white-space: nowrap;
  }

  /* Hide brand when sidebar is open */
  .navbar-shift .brand-text {
    display: none !important;
  }
}

/* Profile Dropdown Button */
.btn-pink {
  background: linear-gradient(45deg, #ff00cc, #9900ff);
  border: none;
  color: white;
  transition: 0.3s;
}

.btn-pink:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 10px #ff00cc, 0 0 20px #ff00cc;
}

/* Dropdown Menu */
.dropdown-menu {
  background-color: #1a001f;
  border: 1px solid #ff00cc;
  color: white;
  min-width: 160px;
}

.dropdown-item {
  color: white;
}

.dropdown-item:hover {
  background-color: #ff00cc;
  color: #1a001f;
}

@media (max-width: 576px) {
  .btn-pink {
    padding: 6px 8px;
  }
}
</style>
